import React from 'react';
import { ArrowRight, MapPin, Clock, Star } from 'lucide-react';
import { businessInfo } from '../data/mock';

const HeroSection = () => {
  const handleWhatsAppClick = () => {
    const message = encodeURIComponent("Olá! Vi o site e quero agendar minha aula experimental grátis no Centro de Lutas Jardim da Penha!");
    window.open(`https://wa.me/${businessInfo.whatsapp}?text=${message}`, '_blank');
  };

  const scrollToPlans = () => {
    const element = document.getElementById('precos');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="hero-section">
      {/* Background Image with Overlay */}
      <div className="hero-background">
        <img
          src="martial_arts_hero_premium_1774630170837.png"
          alt="Treino intenso no Centro de Lutas Jardim da Penha"
          className="hero-image"
        />
        <div className="hero-overlay"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 lg:px-8 relative z-10">
        <div className="max-w-3xl">
          {/* Badge */}
          <div className="inline-flex items-center space-x-2 bg-brand-primary/20 border border-brand-primary/50 rounded-full px-4 py-2 mb-6">
            <Star className="w-4 h-4 text-brand-primary fill-brand-primary" />
            <span className="text-sm font-semibold text-brand-primary uppercase tracking-wide">
              Centro Premium de Artes Marciais
            </span>
          </div>

          {/* Main Headline */}
          <h1 className="hero-title mb-8 animate-fade-in">
            Treine em um Centro de Lutas de Verdade
          </h1>

          {/* Subheadline */}
          <p className="body-large mb-8 text-gray-300 max-w-2xl">
            Disciplina, técnica e evolução em um só lugar. Transforme seu corpo, mente e confiança com treino sério e ambiente premium.
          </p>


          {/* Location & Hours */}
          <div className="flex flex-col sm:flex-row sm:items-center space-y-3 sm:space-y-0 sm:space-x-8 mb-10 text-white/90">
            <div className="flex items-center space-x-3 bg-black/30 backdrop-blur-sm rounded-full px-4 py-2 border border-white/5">
              <MapPin className="w-5 h-5 text-brand-primary drop-shadow-[0_0_8px_rgba(220,38,38,0.5)]" />
              <span className="text-sm font-medium tracking-wide uppercase">{businessInfo.neighborhood}, {businessInfo.city}</span>
            </div>
            <div className="flex items-center space-x-3 bg-black/30 backdrop-blur-sm rounded-full px-4 py-2 border border-white/5">
              <Clock className="w-5 h-5 text-brand-primary drop-shadow-[0_0_8px_rgba(220,38,38,0.5)]" />
              <span className="text-sm font-medium tracking-wide uppercase">{businessInfo.hours}</span>
            </div>
          </div>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
            <button onClick={handleWhatsAppClick} className="btn-primary group">
              Agende Aula Experimental Grátis
              <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
            </button>
            <button onClick={scrollToPlans} className="btn-secondary">
              Ver Planos
            </button>
          </div>

          {/* Social Proof - Removed placeholders A1-A4 as requested */}
          <div className="mt-12">
            <p className="body-medium text-white/90 font-medium">
              <span className="text-brand-primary font-bold">+300 alunos</span> já transformaram suas vidas aqui
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
